export default [
    {
        label: "Documents",
        icon: "icon-folder",
        tableSettings: {
            route: "purchaseOrderDocuments",
            formType: "sidebarRightSide",
            showItemPerPageOption: true,
            showSelectTable: false,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            filter: {  //we filter the table based on this value. if don't want to have filter empty this
                pkId: "", 
            },
            filterEndpoint: "myPoDocuments",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
    {
        label: "Items",
        icon: "icon-list",
        tableSettings: {
            route: "purchaseOrderItems",
            formType: "popup",
            showItemPerPageOption: true,
            showSelectTable: true,
            uploadEndpoint: "/uploadFile", //when field type is file this will be the endpoint to upload the file
            //if don't want to have filter empty this.we filter the table based on this value
            filter: {
                pkId: "", 
            },
            filterEndpoint: "myPoItems",
            showAddBtn: true,
            showActionButton: true, //if this is false the add and edit button will not be shown 
            showEditBtn: true,
        },
    },
]